import axios from 'axios';

const instance = axios.create({
	baseURL: process.env.VUE_APP_API_URL,
});

export function loginUser(params) {
	return instance.post('/api/login.php', params);
}

export function updateUserInfo(info) {
	return instance.post('/api/updateUserAppToken.php', info);
}

export function fetchUserFromLoginToken(params) {
	return instance.post('/api/userFromLoginToken.php', params);
}

// 메인 화면 회원 예약 정보 표시
export function fetchUserReservationSummary(params) {
	return instance.post(
		'/api/reservation/fetchUserReservationSummary.php',
		params,
	);
}

// 지점 예약 시 기본 지점 정보 가져오기
export function fetchReservationDefault(params) {
	return instance.post('/api/reservationDefault.php', params);
}

// 회원 예약 대기 신청 내역
export function fetchUserReservationWaitingList(params) {
	return instance.post(
		'/api/reservation/fetchUserReservationWaitingList.php',
		params,
	);
}

// 예약 대기 취소
export function cancelUserReservationWaiting(params) {
	return instance.post(
		'/api/reservation/cancelUserReservationWaiting.php',
		params,
	);
}

// 정회원 전환
export function updateToRegularUserLevel(params) {
	return instance.post('/api/updateToRegularUserLevel.php', params);
}

// 프로모션 배너
export function fetchBanner() {
	return instance.post('/api/banner.php');
}

export function fetchMileage(params) {
	return instance.post('/api/mileage.php', params);
}

export function fetchMileageDetail(params) {
	return instance.post('/api/mileageDetail.php', params);
}

// 온라인 예약 - 예약 시간 가져오기 (예약 가능, 불가능(=대기 가능 여부 포함) 불러오기)
export function fetchReservationTimeAll(params) {
	return instance.post('/api/reservationAppTimeAll.php', params);
}

// 온라인 예약 - 관리 서비스 가져오기
export function fetchReservationCode() {
	const code = {
		data: [
			{
				name: '관리서비스',
				value: '40011',
			},
			{
				name: '부가서비스',
				value: '40012',
			},
		],
	};
	return new Promise(resolve => {
		setTimeout(() => resolve(code), 200);
	});
}

// 방문 경로
export function fetchVisitPath() {
	const paths = {
		data: [
			{
				key: 'A',
				name: 'TV',
			},
			{
				key: 'B',
				name: '라디오',
			},
			{
				key: 'C',
				name: '신문',
			},
			{
				key: 'D',
				name: '잡지',
			},
			{
				key: 'E',
				name: '인터넷(홈페이지, 블로그 등)',
			},
			{
				key: 'F',
				name: '현수막/전단지',
			},
			{
				key: 'G',
				name: '지인소개',
			},
			{
				key: 'I',
				name: '기타',
			},
		],
	};
	return new Promise(res => {
		setTimeout(() => res(paths), 200);
	});
}

// 온라인 예약 가능 시간대 가져오기
export function fetchAvailableReservationDates(params) {
	return instance.post('/api/availableReservationDates.php', params);
}

// 온라인 예약 하기 (대기신청 유효성검사)
export function saveReservationNew(params) {
	return instance.post('/api/saveReservationNew.php', params);
}

// 온라인 예약 대기 신청
export function insertUserReservationWaiting(params) {
	return instance.post(
		'/api/reservation/insertUserReservationWaiting.php',
		params,
	);
}

export function fetchUserReservationList(params) {
	return instance.post('/api/reservation/fetchUserReservationList.php', params);
}

export function cancelUserReservation(params) {
	return instance.post('/api/reservation/cancelUserReservation.php', params);
}

export function fetchBranchArea() {
	return instance.post('/api/branchArea.php');
}

export function fetchBranchFromAreaName(params) {
	return instance.post('/api/branchFromAreaName.php', params);
}

export function fetchBranchFromAreaCode(params) {
	return instance.post('/api/branchFromAreaCode.php', params);
}

export function fetchBranchAreaFromBranchName(params) {
	return instance.post('/api/branchAreaFromBranchName.php', params);
}

export function fetchPromotion(params) {
	return instance.post('/api/promotion.php', params);
}

export function fetchPromotionDetail(params) {
	return instance.post('/api/promotionDetail.php', params);
}

// 휴대전화 인증
export function sendCertSms(params) {
	return instance.post('/api/sendCertSms.php', params);
}

// 휴대전화 인증번호 체크
export function checkCertNumber(params) {
	return instance.post('/api/checkCertNumber.php', params);
}

// 이미 가입된 휴대전화 번호 체크
export function isValidUserHp(params) {
	return instance.post('/api/isValidUserHp.php', params);
}

// 이미 등록된 아이디인지 체크
export function isValidUserId(params) {
	return instance.post('/api/isValidUserId.php', params);
}

// 회원가입
export function registerUser(params) {
	return instance.post('/api/signup.php', params);
}

// 아이디 찾기
export function findId(params) {
	return instance.post('/api/findId.php', params);
}

// 비밀번호 찾기
export function findPassword(params) {
	return instance.post('/api/findPassword.php', params);
}

// 비밀번호 찾기 - 비밀번호 변경
export function findPasswordUpdate(params) {
	return instance.post('/api/findPasswordUpdate.php', params);
}

// 비밀번호 재확인
export function checkPassword(params) {
	return instance.post('/api/checkPassword.php', params);
}

// 회원 정보 수정 - 휴대전화 번호 변경
export function editUserPhoneNumberUpdate(params) {
	return instance.post(
		'/api/editUserPhoneNumberUpdate.php?update=220919',
		params,
	);
}

// 회원 정보 수정 - 비밀번호 변경
export function editUserPasswordUpdate(params) {
	return instance.post('/api/editUserPasswordUpdate.php', params);
}

// 회원 정보 수정 하기
export function editUserFormUpdate(params) {
	return instance.post('/api/editUserFormUpdate.php', params);
}

// 회원 탈퇴
export function leaveUser(params) {
	return instance.post('/api/leaveUser.php', params);
}

// 지점 지역 목록 조회
export function fetchBranchAreaList() {
	return instance.post('/api/app/fetchBranchAreaList.php');
}

// 지역명으로 지점 목록 조회
export function fetchBranchListFromAreaName(params) {
	return instance.post('/api/app/fetchBranchListFromAreaName.php', params);
}

// 지점 목록 조회
export function fetchShopList(params) {
	return instance.post('/api/shop/fetchShopList.php', params);
}

// 지점 게시판 아이디로 지점 정보 가져오기
export function fetchShopDetailBranch(params) {
	return instance.post('/api/shop/fetchShopDetailBranch.php', params);
}

// 회원 계약 내역 목록 조회
export function fetchUserContractList(params) {
	return instance.post('/api/contract/fetchUserContractList.php', params);
}

// 회원 쿠폰 목록 조회
export function fetchUserCouponList(params) {
	return instance.post('/api/coupon/fetchUserCouponList.php', params);
}

// 회원 1:1 문의 내역 조회
export function fetchUserInquiryList(params) {
	return instance.post('/api/inquiry/fetchUserInquiryList.php', params);
}

// 회원 1:1 문의 상세 조회
export function fetchUserInquiryDetail(params) {
	return instance.post('/api/inquiry/fetchUserInquiryDetail.php', params);
}

// 회원 1:1 문의 댓글 조회
export function fetchUserInquiryReplyList(params) {
	return instance.post('/api/inquiry/fetchUserInquiryReplyList.php', params);
}

// 회원 1:1 문의 게시글 삭제
export function deleteUserInquiry(params) {
	return instance.post('/api/inquiry/deleteUserInquiry.php', params);
}

// 회원 1:1 문의 게시글 작성
export function insertUserInquiry(params) {
	return instance.post('/api/inquiry/insertUserInquiry.php', params);
}

// 회원 1:1 문의 게시글 수정
export function updateUserInquiry(params) {
	return instance.post('/api/inquiry/updateUserInquiry.php', params);
}

// 관리 주기 목록 가져오기
export function fetchAsTermList() {
	const response = {
		data: [
			{
				key: 1,
				value: '0',
				name: '선택하지 않음 (푸시발송 없음)',
			},
			{
				key: 2,
				value: '14',
				name: '2주',
			},
			{
				key: 3,
				value: '21',
				name: '3주',
			},
			{
				key: 4,
				value: '28',
				name: '4주',
			},
			{
				key: 5,
				value: 'other',
				name: '직접 입력',
			},
		],
	};
	return new Promise(resolve => {
		setTimeout(() => resolve(response), 200);
	});
}

// 회원 관리 주기 가져오기
export function fetchUserAsTerm(params) {
	return instance.post('/api/as/fetchUserAsTerm.php', params);
}

// 회원 관리서비스 가져오기 (텐텐쿠폰 스탬프)
export function userAvailableAsHistoryList(params) {
	return instance.post('/api/as/fetchUserAsHistoryAvailable.php', params);
}

// 회원 관리서비스 히스토리 가져오기 (전체 내역)
export function userAllAsHistoryList(params) {
	return instance.post('/api/as/fetchUserAsHistoryAll.php', params);
}

// 지점 코드로 지점명 가져오기
export function branchNameFromBranchCode(params) {
	return instance.post('/api/app/fetchBranchNameFromBranchCode.php', params);
}
